/**
 * Voila — AI Assistant, Copilot and AI Writer
 *
 * Declares one web-accessible-resource entry — assets/* and js/* — matched to every
 * origin with no use_dynamic_url, so its logo, third-party brand logos and its script
 * bundle are all fetchable from any page at a stable URL.
 *
 * assets/logo.png loads through probeImage with no CORS grant, and the stable
 * (non-hashed) js entry points corroborate it.
 *
 * Manifest verified against version 1.8.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cakobppopkpmmglabcdcklncbckjpkcl';

export const voila: ExtensionDefinition = {
  id: ID,
  name: 'Voila – AI Assistant, Copilot and AI Writer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'assets/* and js/* exposed to every origin with no dynamic URL. The logo is ' +
    'CORS-free and the stable js entry points corroborate it.',
  signals: [
    {
      id: 'war-logo-image',
      kind: 'web-accessible-resource',
      description:
        'Load assets/logo.png via <img> — exposed to every origin and readable without ' +
        'a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/logo.png'),
    },
    {
      id: 'war-content-script-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/content-script.js — a stable, non-hashed script entry point.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/content-script.js'),
    },
    {
      id: 'war-standalone-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/standalone.js — a third stable script path, independent of the others.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/standalone.js'),
    },
  ],
};
